<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
import Select from "@/components/c-select";
import Area from "@/components/c-input-area";
import Loading from "@/components/c-loading";
import i18n from "../../../../i18n";
import { projectownerService } from "../../../../services/projectservice/projectowner.service";
import { servicehelpers } from "../../../../services/servicehelpers";

/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Loan Template",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading,
    Button,
    Input,
    Select,
    Area
  },
  data() {
    return {
      isAdd: true,
      fetchingStats: false,
      tryingToSubmit: false,
      title: "loan template",
      breadCrumb: {},

      owner: {},
      genderDataList: {},
      valueUser: 0,
      valueCode: '',
      valueName: '',
      valueNameEn: '',
      valueGender: 0,
      valueDOB: '',
      valuePhoneNo: '',
      valueID: '',
      valueEmail: '',
      valueAddress: '',
      valuePosition: ''

    };
  },
  mounted() {

    this.loadingGenderData();
    
    let hasId = 'id' in this.$route.params;
    this.isAdd = this.fetchingStats = !hasId;
    if(hasId) {
      this.loadingData(this.$route.params.id);     

    } 
  },

  methods: {

    loadingData: function(id) {
      this.fetchingStats = false;
      projectownerService.getOne(id)
        .then(response => {
          
          this.fetchingStats = true;
          this.owner = response.data;

          this.breadCrumb = {
            text: response.data.name,
            active: true,
          };


          this.valueUser = this.owner.user_id;
          this.valueCode = this.owner.code;
          this.valueName = this.owner.name;
          this.valueNameEn = this.owner.name_en;
          this.valueGender = this.owner.sex;
          this.valueDOB = this.owner.dob;
          this.valuePhoneNo = this.owner.phone_no;
          this.valueID = this.owner.id_no;
          this.valueEmail = this.owner.email;
          this.valueAddress = this.owner.address;
          this.valuePosition = this.owner.position;


        });
    },

    loadingGenderData: function() {

      servicehelpers.getGenderData().then(response => {
        this.genderDataList = response;
      });
    },

    submitSave: function() {
      
      this.tryingToSubmit = true;

      let owner = {
        name: this.valueName,
        name_en: this.valueNameEn,
        sex: this.valueGender,
        dob: this.valueDOB,
        phone_no: this.valuePhoneNo,
        id_no: this.valueID,
        email: this.valueEmail,
        address: this.valueAddress,
        position: this.valuePosition,
      };

      console.log(JSON.stringify(owner))

      if(this.isAdd) {
        projectownerService.insert(owner).then(response => {
          if(response.status == 200) {
            
            this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message'),
              icon: "success",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: i18n.t('general.success.yes'),
              cancelButtonText: i18n.t('general.success.no')
            }).then(result => {
              if (!result.value) {
                this.$router.push(this.$route.query.redirectFrom || {
                  name: "setting-owner"
                });
              } 
            });

          }
        });
      } else {
        projectownerService.update(this.$route.params.id, owner).then(response => {
          if(response.status == 200) {
            
            this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message'),
              icon: "success",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: i18n.t('general.success.yes'),
              cancelButtonText: i18n.t('general.success.no')
            }).then(result => {
              if (!result.value) {
                this.$router.push(this.$route.query.redirectFrom || {
                  name: "setting-owner"
                });
              } 
            });

          }
        });
      }

    }

  }
};
</script>

<template>
  <Layout>
    <!-- <PageHeader :items="['']" :title="$t('setting.configuration.loan-template.text')" /> -->
    <div v-if="this.isAdd">
      <PageHeader :items="[{
        text: $t('setting.property.project-owner.text'),
        href: '/setting/owner',
      }, {
        text: $t('setting.property.project-owner.new'),
        active: true
      }]" :title="this.isAdd ? $t('setting.property.project-owner.new') : $t('setting.property.project-owner.edit')" />
    </div>
    <div v-else>
      <PageHeader :items="[{
        text: $t('setting.property.project-owner.text'),
        href: '/setting/owner',
      }, this.breadCrumb]" :title="this.isAdd ? $t('setting.property.project-owner.new') : $t('setting.property.project-owner.edit')" />
    </div>
    <Loading :loaded="fetchingStats" />
    <b-form v-show="fetchingStats" @submit.prevent="submitSave" class="row">
    
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
              <div class="row">
                <div class="col-md-4">
                  <Input 
                    :type="'text'"
                    :id="'code'"
                    v-model="valueCode"
                    :label="'setting.property.project-owner.code'"
                     /> 
                </div>
                <div class="col-md-4">
                  <Input 
                    :type="'text'"
                    :id="'name'"
                    v-model="valueName"
                    :require="true"
                    :label="'setting.property.project-owner.name'"  />
                </div>
                <div class="col-md-4">
                  <Input 
                    :type="'text'"
                    :id="'name-en'"
                    v-model="valueNameEn"
                    :label="'setting.property.project-owner.name-en'"  />
                </div>
              </div>

              <div class="row">
                <div class="col-lg-4">
                  <Select 
                    :text="'name'"
                    :id="'sex'"
                    :text2="'name_en'"
                    v-model="valueGender"
                    :list="this.genderDataList"
                    :label="'setting.property.project-owner.gender'"  />
                </div>
                <div class="col-lg-4">
                  <Input 
                    :type="'text'"
                    :id="'id_no'"
                    v-model="valueID"
                    :require="true"
                    :label="'setting.property.project-owner.id-no'"  />
                </div>
                <div class="col-lg-4">
                  <Input 
                    :type="'date'"
                    :id="'dob'"
                    v-model="valueDOB"
                    :label="'setting.property.project-owner.dob'"  />
                </div>
              </div>

              <div class="row">
                <div class="col-lg-4">
                  <Input 
                    :type="'text'"
                    :id="'position'"
                    v-model="valuePosition"
                    :label="'setting.property.project-owner.position'"  />
                </div>
                <div class="col-md-4">
                  <Input 
                    :type="'text'"
                    :id="'phone_no_1'"
                    v-model="valuePhoneNo"
                    :mask="'### ### ########'"
                    :require="true"
                    :label="'setting.property.project-owner.phone-no'"  />
                </div>
                <div class="col-md-4">
                  <Input 
                    :type="'text'"
                    :id="'email'"
                    v-model="valueEmail"
                    :require="true"
                    :label="'setting.property.project-owner.email'"  />
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <Area 
                    :rows="5"
                    :id="'address'"
                    v-model="valueAddress"
                    :label="'setting.property.project-owner.address'"  />
                </div>
              </div>
              

              <div class="row">
                <div class="col-lg-12">

                  <div inline class="row gy-2 gx-3 align-items-end">
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-x-circle'" 
                        v-bind:buttonType="'button'"
                        v-bind:variant="'danger'"
                        @click="submitCancel()"
                        v-bind:title="$t('general.cancel')"  />
                    </div>
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-save bx-tada'" 
                        v-bind:buttonType="'button'"
                        @click="submitSave()"
                        v-bind:requesting="tryingToSubmit"
                        v-bind:title="$t('general.save')"  />
                    </div>
                  </div>
    
                </div>
              </div>
          
          </div>
        </div>
      </div>
    </b-form> 
  </Layout>
</template>